var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-reservation-success" }, [
    _c("div", { staticClass: "c-reservation-success__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "sc-title" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("BranchReservation.Success.title")) +
            "\n        "
        ),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "sc-text",
        domProps: {
          innerHTML: _vm._s(
            _vm.replaceTranslate(
              _vm.$t("BranchReservation.Success.text"),
              "<strong>" + _vm.orderId + "</strong>",
              "<br><strong>",
              _vm.selectedBranch.custom_reservation_cutoff,
              "</strong><br>"
            )
          ),
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-reservation-success__main" }, [
      _c(
        "div",
        { staticClass: "c-reservation-success__branch" },
        [_c("ReservationSelect")],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "c-reservation-success__delimiter" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "c-reservation-success__product" },
        [_c("ReservationProduct")],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-reservation-success__footer" }, [
      _c(
        "button",
        {
          staticClass: "c-btn c-btn--secondary",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("BranchReservation.Success.button")) +
              "\n        "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sc-icon" }, [
      _c("i", {
        staticClass: "ico ico-tick",
        attrs: { "aria-label": "hidden" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }